import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("控销团队");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("订单审核");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("需要审核");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("不需要审核");

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px"
  }
}, "订单金额 ≥", -1);

const _hoisted_10 = /*#__PURE__*/_createTextVNode("    ");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("导入");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "1. 请下载Excel模版，填写用户信息，保存后上传到系统", -1);

const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "2. 最多可导入1000条信息", -1);

const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "3. 不可输入特殊符号，如“*”", -1);

const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "4. 站点和客户编码都为必填项，若未填则保存不成功", -1);

import { reactive, ref } from 'vue';
import { getVexTableProps } from '@/config';
import { useRoute, useRouter } from 'vue-router';
import { getOrderAuditDivId, getOrderauditMerchandise, getOrderCustomer, getAuditPriceId, updateOrderAutidDivId, deleteByAuditMainId, deleteOrderAutidDivId, deleteOrderCustomer } from '@/request';
import { execlImportCustomer, importCustomerExcel } from '@/request/api';
import { ElMessage, ElMessageBox } from 'element-plus';
import UploadModal from '@/components/UploadModal.vue';
import AddPersonAuditModal from './component/AddPersonAuditModal.vue';
import AddProductModal from './component/AddProductModal.vue';
import AddCustomerModal from './component/AddCustomerModal.vue';
export default {
  name: 'OrderAudit',

  setup(__props) {
    const state = reactive({
      thisCustKeyWord: '',
      isAuditTotalprice: '0',
      limit_price: 0,
      auditPriceId: ''
    });
    const route = useRoute();
    const router = useRouter();
    const supplierId = route.query.supplierId;
    const personTable = ref();
    const orderTable = ref();
    const unAuditTable = ref();
    const uploadOption = {
      action: execlImportCustomer.url + '?supplierId=' + supplierId,
      name: 'customerExcel',
      templateLink: importCustomerExcel.url,
      title: '导入'
    };
    const showUploadModel = ref(false);
    const auditMainId = ref();
    const showAddPersonAuditModal = ref(false);
    const showAddProductModal = ref(false);
    const showAddCustomerModal = ref(false);

    function addPersonAuditSuccess() {
      personTable.value.commitProxy('reload');
    }

    function addPerson() {
      auditMainId.value = null;
      showAddPersonAuditModal.value = true;
    }

    function delPeronAudit() {
      const selectRows = personTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`删除操作可能会影响部分数据的计算，请谨慎操作，确定要删除这${selectRows.length}条数据吗`, '确认删除?').then(() => {
        deleteByAuditMainId({
          __repeat: true,
          __warn: true
        }, {
          params: {
            auditMainIds: selectRows.map(i => i.auditMainId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            personTable.value.commitProxy('query');
          }
        });
      });
    }

    function delUnAuditCustomer() {
      const selectRows = unAuditTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`删除操作可能会影响部分数据的计算，请谨慎操作，确定要删除这${selectRows.length}条数据吗`, '确认删除?').then(() => {
        deleteOrderCustomer({
          __repeat: true,
          __warn: true
        }, {
          params: {
            customerIds: selectRows.map(i => i.customerId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            unAuditTable.value.commitProxy('query');
          }
        });
      });
    }

    function uploadSuccess(data) {
      showUploadModel.value = false;

      if (data.success) {
        unAuditTable.value.commitProxy('reload');
        ElMessage.success('操作成功!');
      }
    }

    function updatePeronAudit(row) {
      auditMainId.value = row.auditMainId;
      showAddPersonAuditModal.value = true;
    }

    function deleteOrder() {
      const selectRows = orderTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`删除操作可能会影响部分数据的计算，请谨慎操作，确定要删除这${selectRows.length}条数据吗`, '确认删除?').then(() => {
        deleteOrderAutidDivId({
          __repeat: true,
          __warn: true
        }, {
          params: {
            auditMerchandiseIds: selectRows.map(i => i.auditMerchandiseId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            orderTable.value.commitProxy('reload');
          }
        });
      });
    } // 初始化价格配置信息


    getAuditPriceId({
      supplierId
    }).then(data => {
      if (data.success && data.data) {
        state.limit_price = data.data.limitPrice;
        state.isAuditTotalprice = data.data.isAuditTotalprice;
        state.auditPriceId = data.data.auditPriceId;
      }
    });

    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    function save() {
      const {
        fullData
      } = orderTable.value.getTableData();
      updateOrderAutidDivId({
        auditPriceId: state.auditPriceId,
        supplierId,
        isAuditTotalprice: state.isAuditTotalprice,
        limitPrice: state.isAuditTotalprice === 0 ? 0 : state.limit_price,
        auditMerchandiseIds: fullData.map(item => item.auditMerchandiseId).join(','),
        limitPrices: fullData.map(item => item.limitPrice).join(','),
        __repeat: true,
        __warn: true
      }).then(data => {
        if (data.success) {
          ElMessage.success('保存成功!');
          goBack();
        }
      });
    }

    const personTableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '审核人',
        field: 'reviewer',
        width: '400px',
        showOverflow: true
      }, {
        title: '被审核人',
        field: 'auditee',
        showOverflow: true
      }, {
        title: '操作',
        width: '100px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getOrderAuditDivId({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId
            }).then(data => {
              var _data$rows;

              data === null || data === void 0 ? void 0 : (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.forEach(item => {
                if (item.isAuditAll === 1) {
                  // 如果是全部审核
                  item.auditee = 'ALL';
                }
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    const orderTableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '发货方',
        field: 'shortName',
        width: '150px',
        showOverflow: true
      }, {
        title: '编码',
        field: 'prodNo',
        width: '200px',
        showOverflow: true
      }, {
        title: '名称',
        field: 'prodName',
        width: '200px',
        showOverflow: true
      }, {
        title: '审核金额',
        field: 'limitPrice',
        width: '180px',
        showOverflow: true,
        slots: {
          default: 'price'
        }
      }, {
        title: '规格',
        field: 'proSpec',
        width: '150px',
        showOverflow: true
      }, {
        title: '厂家',
        field: 'manufacture',
        width: '200px',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getOrderauditMerchandise({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    const unAuditTableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '客户Id',
        field: 'custId',
        width: '200px',
        showOverflow: true
      }, {
        title: '客户名称',
        field: 'custName',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getOrderCustomer({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId,
              thisCustKeyWord: state.thisCustKeyWord
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_input = _resolveComponent("el-input");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/",
        style: {
          "margin-bottom": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 2
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            icon: "Back",
            type: "primary",
            link: "",
            onClick: goBack
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tabs, {
        "model-value": "first"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "人员审核",
          name: "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(personTableOptions), {
            ref_key: "personTable",
            ref: personTable
          }), {
            tools: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              onClick: addPerson
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              onClick: delPeronAudit
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            })]),
            operation: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Edit",
              onClick: $event => updatePeronAudit(row)
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tabs, {
        "model-value": "first"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "订单金额",
          name: "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: state.isAuditTotalprice,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.isAuditTotalprice = $event),
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1,
              size: "large",
              style: {
                "margin-right": "200px"
              }
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 0,
              size: "large"
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", null, [_hoisted_9, _hoisted_10, _createVNode(_component_el_input_number, {
            size: "small",
            modelValue: state.limit_price,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.limit_price = $event)
          }, null, 8, ["modelValue"])], 512), [[_vShow, state.isAuditTotalprice === 1]])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tabs, {
        "model-value": "first"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "订单品种",
          name: "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(orderTableOptions), {
            ref_key: "orderTable",
            ref: orderTable
          }), {
            tools: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              onClick: _cache[2] || (_cache[2] = $event => showAddProductModal.value = true)
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              onClick: deleteOrder
            }, {
              default: _withCtx(() => [_hoisted_12]),
              _: 1
            })]),
            price: _withCtx(({
              row
            }) => [_createVNode(_component_el_input_number, {
              modelValue: row.limitPrice,
              "onUpdate:modelValue": $event => row.limitPrice = $event,
              precision: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tabs, {
        "model-value": "first"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "无需审核客户",
          name: "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(unAuditTableOptions), {
            ref_key: "unAuditTable",
            ref: unAuditTable
          }), {
            tools: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                icon: "Plus",
                onClick: _cache[3] || (_cache[3] = $event => showAddCustomerModal.value = true)
              }, {
                default: _withCtx(() => [_hoisted_13]),
                _: 1
              }), _createVNode(_component_el_button, {
                type: "danger",
                icon: "Delete",
                onClick: delUnAuditCustomer
              }, {
                default: _withCtx(() => [_hoisted_14]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "UploadFilled",
                plain: "",
                onClick: _cache[4] || (_cache[4] = $event => showUploadModel.value = true)
              }, {
                default: _withCtx(() => [_hoisted_15]),
                _: 1
              }), _createVNode(_component_el_input, {
                type: "text",
                style: {
                  "width": "200px",
                  "margin": "0 10px 0 20px"
                },
                placeholder: "客户编码/名称",
                modelValue: state.thisCustKeyWord,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.thisCustKeyWord = $event)
              }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                type: "primary",
                icon: "Search",
                onClick: _cache[6] || (_cache[6] = $event => unAuditTable.value.commitProxy('reload'))
              }, {
                default: _withCtx(() => [_hoisted_16]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })]),
        _: 1
      }), _createVNode(AddPersonAuditModal, {
        modelValue: showAddPersonAuditModal.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showAddPersonAuditModal.value = $event),
        onSuccess: addPersonAuditSuccess,
        auditMainId: auditMainId.value
      }, null, 8, ["modelValue", "auditMainId"]), _createVNode(AddProductModal, {
        supplierId: _unref(supplierId),
        modelValue: showAddProductModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAddProductModal.value = $event),
        onSuccess: _cache[9] || (_cache[9] = $event => orderTable.value.commitProxy('reload'))
      }, null, 8, ["supplierId", "modelValue"]), _createVNode(AddCustomerModal, {
        supplierId: _unref(supplierId),
        modelValue: showAddCustomerModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showAddCustomerModal.value = $event),
        onSuccess: _cache[11] || (_cache[11] = $event => unAuditTable.value.commitProxy('reload'))
      }, null, 8, ["supplierId", "modelValue"]), _createVNode(UploadModal, {
        option: uploadOption,
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => showUploadModel.value = $event),
        onSuccess: _cache[13] || (_cache[13] = $event => unAuditTable.value.commitProxy('reload'))
      }, {
        help: _withCtx(() => [_hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};